import React, { FC, useContext, useState } from 'react';
import { AvailableShippingMethods, ShippingMethod } from 'shared/types/cart/CustomShippingMethod';
import useClassNames from 'helpers/hooks/useClassNames';
import Costs from './components/costs';
import DiscountForm from './components/discount-form';
import PaymentMethods from './components/payment-methods';
import { OrderSummaryProps } from '../order-summary/types';
import ShippingForm from './components/shipping-form';
import { AccountContext } from '../../../../context/account';

const OrderPaymentSection: FC<OrderSummaryProps> = ({
  discounts,
  onApplyDiscountCode,
  onRemoveDiscountCode,
  estimateShipping,
  isEmpty,
  className,
  paymentMethods = [],
  button,
  isSideCart = false,
  dataReference = 'cart',
  classNames,
  order,
  isCheckoutPage = false,
  // TODO: Added as part of ECOM-340. Need to be revisited properly after MVP.
  isShippingStateCompleted,
  ...props
}) => {
  const { defaultShippingAddress, loggedIn } = useContext(AccountContext);

  const isCartWithItems = !isEmpty && !order;

  const [localShippingData, setLocalShippingData] = useState<AvailableShippingMethods>();
  const updateLocalShippingData = (data?: AvailableShippingMethods) => {
    setLocalShippingData(data);
  };
  const [localShippingMethod, setLocalShippingMethod] = useState<ShippingMethod>();
  const updateLocalShippingMethod = (data?: ShippingMethod) => {
    setLocalShippingMethod(data);
  };

  const infoContainerClassName = useClassNames([
    isCartWithItems && !isCheckoutPage ? 'border-t-2 border-stroke-primary' : '',
    'bg-white',
    classNames?.infoContainer,
  ]);

  return (
    <div className={className} {...props}>
      {isCartWithItems && !isCheckoutPage && (
        <>
          {!isSideCart && (
            <ShippingForm
              localShippingData={localShippingData}
              localShippingMethod={localShippingMethod}
              onChangeAddress={() => {
                updateLocalShippingData(undefined);
                updateLocalShippingMethod(undefined);
              }}
              onShippingMethodChange={updateLocalShippingMethod}
              className="mt-16"
              onCalculateShipping={async (zipcode) => {
                const shippingData = await estimateShipping?.({ zipcode });
                if (shippingData) {
                  setLocalShippingData(shippingData);
                  return shippingData;
                }
              }}
              customerZipcode={loggedIn ? defaultShippingAddress?.postalCode : undefined}
              accordionProps={{ defaultOpen: loggedIn && !!defaultShippingAddress?.postalCode }}
            />
          )}
          <DiscountForm
            className={classNames?.applyDiscountButton}
            discounts={discounts}
            onApplyDiscountCode={onApplyDiscountCode}
            onRemoveDiscountCode={onRemoveDiscountCode}
          />
        </>
      )}

      <div className={infoContainerClassName}>
        <Costs
          order={order}
          dataReference={dataReference}
          selectedLocalShippingMethod={isCartWithItems ? localShippingMethod : undefined}
          totalAmountClassName={classNames?.totalAmount}
          subCostsContainerClassName={classNames?.subCostsContainer}
          subCostClassName={classNames?.subCost}
          isCheckoutPage={isCheckoutPage}
          // TODO: Added as part of ECOM-340. Need to be revisited properly after MVP.
          isShippingStateCompleted={isShippingStateCompleted}
        />

        {button}

        {paymentMethods.length > 0 && <PaymentMethods paymentMethods={paymentMethods} isSideCart={isSideCart} />}
      </div>
    </div>
  );
};

export default OrderPaymentSection;
